import { defineComponent, reactive, computed } from 'vue';
import Image from '@hems/component/src/image/Image2.vue';
import { DateHelper } from '@hems/util';
import { MAPPER_PERIOD_DATA } from '@hems/util/src/constant/mapper';
export default defineComponent({
    name: 'MobileSelector',
    components: {
        Image,
    },
    props: {
        selectedDate: {
            type: String,
            default: '',
        },
    },
    emits: ['changeDateMode', 'openCalendar'],
    setup(props, { emit }) {
        const state = reactive({
            byDate: MAPPER_PERIOD_DATA.DAY, // TODO: TS Phase3에서 수정 예정
        });
        function changeButton(value) {
            state.byDate = value;
            emit('changeDateMode', state.byDate);
        }
        return {
            state,
            displayDate: computed(() => DateHelper.getSimpleDateFormat(props.selectedDate, state.byDate)),
            changeButton,
            MAPPER_PERIOD_DATA,
        };
    },
});
